import React from 'react';
import { useTranslations } from 'next-intl';
import { PageType, useGTM } from '@/features/Analytics';
import { Button } from '@/shared/ui/button';
import type { ButtonVariants } from '@/shared/ui/button';
import { MedcenterPhonesButtons } from './MedcenterPhonesButton';
import socialIcons from '@/shared/assets/sprites/social.sprite.svg';
import type { IMedcenterDetails } from '@/entities/medcenter/model/types';
interface Props {
  medcenter: IMedcenterDetails;
  hasPhones: boolean;
  classes?: string;
  btnVariants?: ButtonVariants;
}

// @todo: переписать на виджет, чтобы кнопки действий были единым виджетом с докторами.
export const MedcenterBookingButtons: React.FC<Props> = ({
  medcenter,
  hasPhones
}) => {
  const {
    trackEvent
  } = useGTM(PageType.MEDCENTER_PROFILE);
  const t = useTranslations('medcenter');
  const handleClickWhatsapp = () => {
    trackEvent('click_whatsapp');
    const phoneNumber = medcenter.whatsapp;
    if (phoneNumber) {
      const message = t('whatsapp.placeholder');
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
    }
  };
  return <div className="flex w-full items-center gap-2" data-sentry-component="MedcenterBookingButtons" data-sentry-source-file="MedcenterBookingButtons.tsx">
      {hasPhones && <MedcenterPhonesButtons medcenter={medcenter} />}
      {medcenter.whatsapp && <Button variant={'whatsapp'} className="flex items-center justify-center p-2" onClick={handleClickWhatsapp}>
          <svg className="size-9 fill-current text-lightGreen">
            <use xlinkHref={`${socialIcons}#whatsapp`}></use>
          </svg>
        </Button>}
    </div>;
};